import { toastr } from 'react-redux-toastr';
import adminUpdateBookingRiskReview from './adminUpdateBookingRiskReview.gql';

export default function updateBookingRiskReview(bookingId, reviewStatus) {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.mutate({
        mutation: adminUpdateBookingRiskReview,
        variables: {
          bookingId,
          reviewStatus
        }
      });

      if (data?.adminUpdateBookingRiskReview?.status === 200) {
        toastr.success('Success', 'Scam risk review has been updated.');
        return {
          status: 200
        };
      }

      const errorMessage = data?.adminUpdateBookingRiskReview?.errorMessage || 'Oops! Something went wrong. Please try again.';
      toastr.error('Error!', errorMessage);
      return {
        status: 400
      };
    } catch (err) {
      toastr.error('Error!', err);
      return {
        status: 400
      };
    }
  };
}
